export default {
  id: "compare-routes",
  title: "Compare routes & set active",
  summary: "Compare routes side by side and choose the one to follow",
  minutes: 3,
  steps: [
    {
      title: "Compare routes & set active",
      text: "Compare several routes of a voyage, e.g. a time- and a fuel-optimised one, and decide which one the vessel should follow.<br><br>You need at least two routes in a voyage. The tutorial <b>Plan an optimised route</b> shows how to create one.",
    },
    {
      anchor: "drawer-fleet",
      skipIf: "fleet-panel",
      click: true,
      title: "Open the Fleet Explorer",
      text: "Click <b>Fleet Explorer</b>.",
      side: "right",
    },
    {
      anchor: "fleet-panel",
      skipIf: "fleet-routes",
      until: "fleet-routes",
      title: "Open the voyage",
      text: "Click your vessel. If it is on a voyage, its routes open directly. Otherwise click the voyage you want to compare routes for.",
      side: "right",
    },
    {
      anchor: "fleet-routes",
      title: "Select routes",
      text: "Click the routes you want to compare. Selected routes are highlighted and shown on the map.",
      side: "right",
    },
    {
      anchor: "fleet-table-button",
      click: true,
      title: "Open the table",
      text: "Click <b>Table</b>. It is enabled as soon as at least one route is selected.",
      side: "bottom",
    },
    {
      anchor: "table-cards",
      title: "Route cards",
      text: "Each route has a card. The <b>active</b> route is the reference. The other cards show what they save or lose against it:<ul><li><b>Time</b>: earlier or later arrival.</li><li><b>Fuel</b>: tons and cost.</li><li><b>Warnings</b>: fewer or more weather and risk zone warnings.</li></ul>Green bars mean better, red bars mean worse.",
      side: "top",
    },
    {
      anchor: "table-view-switch",
      title: "Waypoints",
      text: "Switch to <b>Waypoints</b> to see each route point by point with time, position, speed and weather.",
      side: "bottom",
    },
    {
      anchor: "route-actions",
      title: "Set the route to follow",
      text: "Decided? Open the <b>⋮</b> menu of the route in the Fleet Explorer and choose <b>Set as Active</b>. The previous active route is archived. A draft must be saved first.",
      side: "left",
    },
  ],
}
